module.exports = __webpack_public_path__ + "static/media/Half_W_Art_Title_01.a1bc9db8.csv";